import { render, staticRenderFns } from "./backend.vue?vue&type=template&id=5337bc9b&scoped=true&"
import script from "./backend.vue?vue&type=script&lang=js&"
export * from "./backend.vue?vue&type=script&lang=js&"
import style0 from "./backend.vue?vue&type=style&index=0&id=5337bc9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5337bc9b",
  null
  
)

export default component.exports